import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const WalletDetails = lazy(() => import('../../container/investor/wallet/WalletDetails'));

function FarmRoute() {
  return (
    <Routes>
      <Route path="details" element={<WalletDetails />} />
    </Routes>
  );
}

export default FarmRoute;
